var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-0 my-auto text-center"},[_c('img',_vm._b({staticClass:"w-full my-0 mx-auto max-w-2xl lg:max-w-4xl",attrs:{"src":_vm.webpImageUrl}},'img',_vm.disalbeCopy,false))])}
var staticRenderFns = []

export { render, staticRenderFns }